<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="goback">
        <div @click="goback">
          <i class="el-icon-arrow-left"></i>
          <span>随手拍</span>
        </div>
      </div>
      <img class="phone" src="~@/assets/photoCasually/phone.png" alt="" />
      <div class="content">
        <div class="filed">
          <div class="filed_label">描述内容</div>
          <div class="value_textarea">
            <van-field
              v-model="formData.content"
              rows="3"
              type="textarea"
              placeholder="请输入描述"
              maxlength="200"
              show-word-limit
            />
          </div>
        </div>
        <div class="line"></div>
        <div class="filed">
          <div class="filed_label">上传图片</div>
          <div class="img_list">
            <div class="item_img" v-for="(item, ind) in imgList" :key="ind">
              <img :src="imgUrl + item" alt="" @click="previewImg(item)" />
              <img
                src="~@/assets/photoCasually/delete.png"
                alt=""
                @click="deleteImg(item)"
              />
            </div>
            <div class="item_add">
              <img
                src="~@/assets/photoCasually/casually.png"
                alt=""
                @click="showOverlay = true"
              />
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="filed">
          <div class="filed_label">类型</div>
          <div class="value_select">
            <el-select v-model="formData.rsTypeId" placeholder="请选择类型">
              <el-option
                v-for="item in optionType"
                :key="item.id"
                :label="item.typeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="line"></div>
        <div class="filed">
          <div class="filed_label">所属园区</div>
          <div class="value_select">
            <el-select
              v-model="formData.rsPlaceId"
              placeholder="请选择所属园区"
            >
              <el-option
                v-for="item in optionPlace"
                :key="item.id"
                :label="item.placeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="line"></div>
        <div class="filed">
          <div class="filed_label">位置</div>
          <div class="value_select">
            <el-input v-model="formData.place" placeholder="请输入位置">
            </el-input>
          </div>
        </div>
      </div>
      <div class="myCasually">
        <div class="title">我的随手拍</div>
        <div class="causally_list" v-if="myCasuallyList.length > 0">
          <div
            class="causally_item"
            v-for="item in myCasuallyList"
            :key="item.id"
            @click="toDetail(item)"
          >
            <div class="left">{{ item.createTime }}上传</div>
            <div class="right">
              <span v-if="item.state == 1" class="sp1">待处理</span>
              <span v-if="item.state == 2" class="sp2">已处理</span>
              <span v-if="item.state == 3" class="sp3">已评价</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div v-else class="empty">暂无数据...</div>
      </div>
      <div class="manage" v-if="isAdmin == 1">
        <div class="title">
          <span>任务详情</span>
          <div class="title_right">
            <el-select
              v-model="manageValue"
              placeholder="请选择"
              @change="getAdmin"
            >
              <el-option label="待处理" value="1"></el-option>
              <el-option label="已处理" value="2"></el-option>
              <el-option label="已评价" value="3"></el-option>
            </el-select>
            <div @click="toBackend" v-if="redirect">管理后台 ></div>
          </div>
        </div>
        <div class="line"></div>
        <div class="manage_list" v-if="manageList.length > 0">
          <div
            class="manage_item"
            v-for="item in manageList"
            :key="item.id"
            @click="toManage(item)"
          >
            <div class="left">{{ item.createTime }}</div>
            <div class="con">{{ item.empName }}</div>
            <div class="right">
              <span v-if="item.state == 1" class="sp1">待处理</span>
              <span v-if="item.state == 2" class="sp2">已处理</span>
              <span v-if="item.state == 3" class="sp3">已评价</span>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </div>
        <div v-else class="empty">暂无数据...</div>
      </div>
      <div class="footer">
        <el-button class="btn1" @click="submit">提交</el-button>
        <el-button class="btn2" @click="no">取消</el-button>
      </div>
    </div>
    <van-overlay :show="showOverlay" @click="showOverlay = false">
      <div class="overlayFooter">
        <div @click.stop="openCamera">拍摄</div>
        <div class="line"></div>
        <el-upload
          :on-success="handleChange"
          :action="`${upload}/file/upload`"
          :limit="5"
          :show-file-list="false"
        >
          从相册选择
        </el-upload>
        <div class="line"></div>
        <div @click.stop="showOverlay = false">取消</div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
// import api from "@/apis/evaluation";
// import moment from "moment";
import apis from "@/apis/photoCasually";
import moment from "moment";
import { ImagePreview } from "vant";
import { redirectRoute } from "@/utils/tools";
export default {
  components: {},
  data() {
    return {
      formData: {
        content: "",
        place: "",
        rsTypeId: "",
        rsPlaceId: "",
      },
      imgList: [],
      optionType: [],
      optionPlace: [],
      showOverlay: false,
      myCasuallyList: [],
      manageList: [],
      manageValue: "1",
      imgUrl: "",
      upload: "",
      userinfo: {},
      isAdmin: 2,
      redirect: false,
    };
  },
  mounted() {
    this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    this.imgUrl = apis.imgUrl;
    this.upload = apis.upload;
    this.getQueryByType();
    this.queryByPlace();
    this.getMyRs();
    this.getAdmin();
    this.getIsAdmin();      
    this.getRedirect();
  },
  methods: {
    // pc还是移动
    getRedirect() {
      this.redirect = redirectRoute();
    },
    // 跳转后台
    toBackend(){
      this.$router.push("/photoCasually/backend/historySearch");
    },
    // 查看详情
    toDetail(item) {
      this.$router.push({
        path: "/photoCasually/myCasually",
        query: {
          id: item.id,
        },
      });
    },
    // 跳转
    toManage(item) {
      this.$router.push({
        path: "/photoCasually/adminCausally",
        query: {
          id: item.id,
        },
      });
    },
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 查询类型
    getQueryByType() {
      apis.queryByType().then((res) => {
        if (res.code == 200) {
          this.optionType = res.data;
        }
      });
    },
    // 查询地点
    queryByPlace() {
      apis.queryByPlace().then((res) => {
        if (res.code == 200) {
          this.optionPlace = res.data;
        }
      });
    },
    // 我的随手拍
    getMyRs() {
      apis
        .myRs({
          empNo: this.userinfo.username,
        })
        .then((res) => {
          if (res.code == 200) {
            this.myCasuallyList = res.data;
            this.myCasuallyList.length > 0 &&
              this.myCasuallyList.forEach(
                (item) =>
                  (item.createTime = moment(item.createTime).format(
                    "YYYY-MM-DD"
                  ))
              );
          }
        });
    },
    // 管理员列表
    getAdmin() {
      const params = {
        empNo: this.userinfo.username,
        state: this.manageValue,
      };
      apis.adminRs(params).then((res) => {
        if (res.code == 200) {
          this.manageList = res.data;
          this.manageList.length > 0 &&
            this.manageList.forEach(
              (item) =>
                (item.createTime = moment(item.createTime).format("YYYY-MM-DD"))
            );
        }
      });
    },
    // 是否管理员
    getIsAdmin() {
      apis
        .isAdmin({
          empNo: this.userinfo.username,
        })
        .then((res) => {
          if (res.code == 200) {
            this.isAdmin = res.data.idAdmin;
          }
        });
    },
    // 提交
    submit() {
      if (!this.formData.rsTypeId) return this.$message.error("请选择类型");
      if (!this.formData.rsPlaceId)
        return this.$message.error("请选择所属园区");
      if (this.imgList.length == 0) return this.$message.error("请上传照片");
      if (!this.formData.content) return this.$message.error("请输入描述");
      const params = {
        empNo: this.userinfo.username,
        rsTypeId: this.formData.rsTypeId,
        rsPlaceId: this.formData.rsPlaceId,
        content: this.formData.content,
        image: this.imgList.join(","),
        place: this.formData.place,
      };
      apis.apply(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("提交成功");
          this.formData.content = "";
          this.imgList = [];
          this.formData.place = "";
          this.formData.rsTypeId = "";
          this.formData.rsPlaceId = "";
          this.getMyRs();
          this.getAdmin();
        }
      });
    },
    // 返回
    no() {
      this.$router.go(-1);
    },
    // 上传
    handleChange(file) {
      console.log(file, "file");
      console.log(this.imgList, "imgList");
      this.imgList.push(file.id);
    },
    // 拍摄
    openCamera() {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.capture = "camera"; // 调用摄像头
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (file) {
          console.log(file, "file");
          const params = new FormData();
          params.append("file", file);
          apis.getUpload(params).then((res) => {
            this.imgList.push(res.id);
            this.showOverlay = false;
          });
        }
      };
      input.click();
    },
    // 删除图片
    deleteImg(id) {
      this.imgList = this.imgList.filter((item) => item != id);
    },
    // 放大预览
    previewImg(id) {
      console.log(id);
      // ImagePreview([this.imgUrl + id]);
      ImagePreview({
        images: [this.imgUrl + id],
        closeable: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 306px * $zoom;
    ::v-deep {
      .van-dropdown-item {
        width: 306px * $zoom !important;
        margin: auto;
      }
    }
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 40px 0;
  background: url("~@/assets/photoCasually/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    display: none;
    width: 0;
  }
  .goback {
    margin: 10px 40px 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      display: flex;
      align-items: center;
      width: 100%;
    }

    i {
      font-weight: bold;
      font-size: 48px;
    }

    span {
      font-size: 34px;
      flex-shrink: 0;
      margin: 0 auto;
      font-weight: bold;
    }

    .goback_search {
      margin-left: 20px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 80px;
      height: 80px;
      // width: 58vw;
      padding: 0 30px 0 10px;

      align-items: center;
      justify-content: space-between;

      ::v-deep .el-input {
        flex: 1;
        height: 100%;

        &__inner {
          height: 100%;
          border: none;
          font-size: 28px;
          border-radius: 80px;
        }
      }

      i {
        font-size: 38px;
        margin-right: 10px !important;
      }
    }
  }
  .phone {
    width: 535px;
    height: 240px;
    margin: 0 auto;
  }
  .content {
    background: #fff;
    border-radius: 30px;
    box-shadow: 0px -4px 27px 0px rgba(0, 0, 0, 0.07);
    padding: 40px 30px;
    width: 90%;
    margin: 0 auto;
    .filed_label {
      color: #969b9e;
      font-size: 30px;
    }
    .value_textarea {
      margin-top: 20px;
      ::v-deep {
        .van-cell {
          padding: 0;
          border: 1px solid #e4e6e8;
          border-radius: 20px;
        }
        .van-field__control {
          padding: 15px 20px;
        }
        .van-field__word-limit {
          padding: 0 20px 20px 0;
        }
      }
    }
    .line {
      width: 100%;
      height: 2px;
      background: #e4e6e8;
      margin: 30px 0 30px 0;
    }
    .img_list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 20px;
      .item_img {
        display: flex;
        align-items: center;
        position: relative;
        img {
          width: 170px;
          height: 130px;
          margin: 0 20px 20px 0;
          border-radius: 20px;
        }
        img:nth-child(2) {
          width: 30px;
          height: 30px;
          position: absolute;
          right: -15px;
          top: -15px;
        }
      }
      .item_add {
        width: 170px;
        height: 130px;
        background: #f1f2f4;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        img {
          width: 44px;
          height: 38px;
        }
      }
    }
    .value_select {
      margin-top: 20px;
      .el-select {
        width: 100%;
      }
    }
    ::v-deep {
      .el-input__inner {
        height: 90px;
        border-radius: 20px;
      }
    }
  }
  .myCasually {
    background: #fff;
    border-radius: 30px;
    padding: 40px 30px;
    width: 90%;
    margin: 40px auto 0;
    .title {
      font-size: 30px;
      color: #000;
      font-weight: bold;
    }
    .causally_list {
      .causally_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        border-bottom: 1px solid #e4e6e8;
        padding-bottom: 30px;
        .left {
          font-size: 26px;
          color: #969b9e;
        }
        .right {
          font-size: 28px;
          font-weight: bold;
          span {
            margin-right: 15px;
          }
          .sp1 {
            color: #ff6311;
          }
          .sp2 {
            color: #4fa27d;
          }
          .sp3 {
            color: #282b32;
          }
        }
      }
      .causally_item:last-child {
        padding-bottom: 0;
        border: none;
      }
    }
  }
  .manage {
    background: #fff;
    border-radius: 30px;
    padding: 40px 30px;
    width: 90%;
    margin: 40px auto 0;
    .title {
      font-size: 30px;
      color: #000;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      .el-select {
        width: 200px;
      }
      ::v-deep {
        .el-input__inner {
          height: 80px;
          border-radius: 20px;
        }
      }
      .title_right{
        display: flex;
        align-items: center;
        div{
          font-weight: normal;
          margin-left: 30px;
        }
      }
    }
    .line {
      width: 100%;
      height: 2px;
      background: #e4e6e8;
      margin: 0 0 30px 0;
    }
    .manage_list {
      .manage_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;
        border-bottom: 1px solid #e4e6e8;
        padding-bottom: 30px;
        .left {
          font-size: 26px;
          color: #969b9e;
        }
        .con {
          font-size: 28px;
        }
        .right {
          font-size: 28px;
          font-weight: bold;
          span {
            margin-right: 15px;
          }
          .sp1 {
            color: #ff6311;
          }
          .sp2 {
            color: #4fa27d;
          }
          .sp3 {
            color: #282b32;
          }
        }
      }
      .manage_item:last-child {
        padding-bottom: 0;
        border: none;
      }
    }
  }
  .empty {
    display: flex;
    justify-content: center;
    font-size: 30px;
    margin-top: 30px;
    color: #ccc;
  }
  .footer {
    width: 90%;
    margin: 0 auto;
    .btn2 {
      border: none;
      background: none;
      color: #969b9e;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 0 0 30px !important;
      border-radius: 15px;
    }
    .btn1 {
      border: 1px solid #4fa27d;
      background: #4fa27d;
      color: #fff;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 60px 0 30px;
      border-radius: 15px;
    }
  }
}
</style>

<style lang="scss">
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .overlayFooter {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .overlayFooter {
    width: 306px * $zoom;
    left: 50% !important;
    transform: translateX(-50%);
  }
}
.overlayFooter {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  font-size: 34px;
  text-align: center;
  border-radius: 30px 30px 0 0;
  div:nth-child(1) {
    margin-top: 30px;
    margin-bottom: 30px;
  }
  div:nth-child(3) {
    // margin-top: 30px;
  }
  div:nth-child(5) {
    margin: 30px 0;
  }
  .line {
    width: 100%;
    height: 2px;
    background: #e4e6e8;
  }
}
</style>
